import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

/**
 * Hook for authentication state and navigation.
 */
export function useAuth() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading } = useAuthStore();

  useEffect(() => {
    if (isLoading) return;

    const publicPaths = ['/', '/login', '/register'];
    const isPublicPath = publicPaths.includes(location.pathname);

    if (!user && !isPublicPath) {
      navigate('/login', { replace: true });
    } else if (user && isPublicPath) {
      navigate('/', { replace: true });
    }
  }, [user, isLoading, location.pathname, navigate]);

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
  };
}
